import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AppConfig } from '../../../../assets/config/appconfig';
import { StateService } from '../state/state.service';

@Injectable()
export class AppInsightsService {

    private appInsights: ApplicationInsights = new ApplicationInsights({
        config: { instrumentationKey: this._appConfig.settings.appInsightsKey } 
    });

    constructor(private _appConfig: AppConfig, private stateService: StateService) {
        this.appInsights.loadAppInsights();
    }

    logPageView(name?: string, url?: string, properties?: any) {
        properties = properties ?? { AccountNumber: this.stateService.getAccountNumber() };
        this.appInsights.trackPageView({
            name: name,
            uri: url,
            properties: properties
        });
    }

    logEvent(name: string, properties?: any) {
        properties = properties ?? { AccountNumber: this.stateService.getAccountNumber() };
        this.appInsights.trackEvent({ name: name }, properties);
    } 
} 